// The "Shipping Address" fold the order and subscription cards share.

import { House } from 'lucide-react';
import { FieldRow } from './field-row';
import { SectionCard } from './section-card';
import type { WorkspaceAddressDto } from './types';

export function ShippingAddressSection({ address }: { address: WorkspaceAddressDto }) {
  return (
    <SectionCard icon={<House className="size-3.5" />} title="Shipping Address">
      <div className="flex flex-col gap-1.5">
        {address.name && <FieldRow label="Name" value={address.name} />}
        {address.address1 && <FieldRow label="Address 1" value={address.address1} />}
        {address.address2 && <FieldRow label="Address 2" value={address.address2} />}
        {address.city && <FieldRow label="City" value={address.city} />}
        {address.province && <FieldRow label="State" value={address.province} />}
        {address.country && <FieldRow label="Country" value={address.country} />}
        {address.zipcode && <FieldRow label="Zipcode" value={address.zipcode} />}
      </div>
    </SectionCard>
  );
}
